import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseService } from './base.service';

@Injectable()
export class TimerService {

    private _count: number = 0;
    private _timeoutSeconds: number = 1200; //20 דקות 
    private timer;
    private resetOnTrigger: boolean = false;
    private lastUserActivityTime = 0;
    public timeoutExpired: Subject<number> = new Subject<number>();

    constructor (private base:BaseService) {
        this.startTimer();
    }

    public setLastUserActivityTime() {  // store the latest time of mouse clicking on appComponent
        
        this.lastUserActivityTime = new Date().getTime();
    }

    private isUserActive() {    // User is active if he clicked mouse during last 10 minutes
        
        let currentTime = new Date().getTime();
        let timeDifference = currentTime - this.lastUserActivityTime;
        return (timeDifference <= 600000);
    }

    public startTimer() {
        this._count = 0;
        this.timer = setTimeout(() => {
            this.timerComplete();
        }, this._timeoutSeconds * 1000);
    }

    public stopTimer() {
        if (this.timer)
            clearTimeout(this.timer);
    }

    public resetTimer() {
        this.stopTimer();
        this.startTimer();
    }
    
    private timerComplete() {
        
        if (this.isUserActive()) { // if user is active don't show confirmation and send any request to server
            this.resetTimer();
            this.base.checkIsExistsID('0000').toPromise();
        } else {
            this.timeoutExpired.next(++this._count);

            if (this.resetOnTrigger) {
                this.startTimer();
            }
        }
    }
}

